export const BUTTON_VARIANTS = {
	PRIMARY: "primary",
	SECONDARY: "secondary",
	IMAGE: "image",
	BASIC: "basic",
	AS_LINK: "As Link",
	JUMBO: "jumbo",

};

export const CTA_ON_CLICK_FUNCTION_IDS = {
	OPEN_CONDITIONS_MENU: "Open Conditions Menu",
	OPEN_SERVICE_MENU: "Open Services Menu",
	OPEN_SMART_RECRUIT_WIDGET: "Open Smart Recruit Widget",
	DOWNLOAD : "Download",
	OPEN_CHAT : "Open Chat",
	OPEN_CHAT_MESSAGE : "Open Chat Message",
	OPEN_YOUFOODZ_TOS : "Open YouFoodZ Terms",
	OPEN_WL_TOS : "Open WL TOS",
	OPEN_PRESC_UPD : "Open Prescription Update",
	OPEN_MEDCERT_PREV : "Open Medcert Preview",
	OPEN_MEDCERT_EMP : "Open Medcert Employers"
};

export const BUTTON_STYLES = {
	ROUNDED: "Rounded",
	WHITE: "white-button",
	SMALLER_WIDTH: "Smaller Width - 80%",
	WHITE_OUTLINE: "White Border",
	ORANGE: "Orange",
	FULL_WIDTH: "Full width",
	FIT_CONTENT: "Fit Content",
	CENTERED: "Centered In Container",
	TEXT_SHADOW: "Text Shadow",
	TEXT_LARGE: "Text Large",
	REVERSE: "Reverse"
};

export const WRAPPER_STYLES_ATTRIBUTES = [
	BUTTON_STYLES.FIT_CONTENT,
	BUTTON_STYLES.FULL_WIDTH,
	BUTTON_STYLES.CENTERED,
	BUTTON_STYLES.SMALLER_WIDTH,
];

export const BUTTON_STYLING_CLASS_MAP = {
	[BUTTON_STYLES.ROUNDED]: `rounded`,
	[BUTTON_STYLES.WHITE]: `!bg-white !text-black`,
	[BUTTON_STYLES.WHITE_OUTLINE]: `!border-white !border-solid !border`,
	[BUTTON_STYLES.SMALLER_WIDTH]: `md:w-full m-auto`,
	[BUTTON_STYLES.ORANGE]: `!bg-is2-yellow-500 !text-white`,
	[BUTTON_STYLES.SMALLER_WIDTH]: `[&_button]:w-[90%]`,
	[BUTTON_STYLES.FULL_WIDTH]: `[&_button]:w-full`,
	[BUTTON_STYLES.FIT_CONTENT]: `[&_button]:w-fit`,
	[BUTTON_STYLES.CENTERED]: `m-auto`,
	[BUTTON_STYLES.TEXT_LARGE]: `!text-is2_lg !py-[11px] !px-8`,
};

export const BUTTONTEXT_STYLING_CLASS_MAP = {
	[BUTTON_STYLES.TEXT_SHADOW]: `[text-shadow:0_0.5px_1.5px_rgba(46,19,4,0.65),_0_4px_9.8px_rgba(59,36,22,0.40)] font-bold`,
};

export const HEADER_STYLES = {
	GRADIENT: "Gradient",
};

export const HEADER_STYLING_CLASS_MAP = {
	[HEADER_STYLES.GRADIENT]: `bg-[linear-gradient(226deg,#006AFF_35.59%,_#0065F2_73.08%,#0049AF_90.96%)] 
							   [box-shadow:inset_0_-40px_35.1px_-23px_rgba(0_0_0_0.05)]`,
							   
};
